import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
})
export class ImageComponent {
  /**
   * The image src path
   */
  @Input() src;

  /**
   * Image alt text
   */
  @Input() alt;

  /**
   * Not available image placeholder
   */
  imageNotAvailable = './assets/images/img-unavailable-large-x2.png';

  /**
   * Tracks local state of image loading
   */
  isLoading = true;

  /**
   * Anonymous function used to extend swiper functionality
   */
  fn = () => undefined;

  /**
   * Sets image loading state
   */
  hideLoader() {
    this.isLoading = false;
  }

  /**
   * Sets image error state
   */
  error() {
    this.hideLoader();
    this.src = this.imageNotAvailable;
  }
}
